/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function ($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');

	var modules = {};
	var components = {};
	var pages = {};

	/* Modules */
	var createModule = function createModule(module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageChange: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};

	var exportModule = function exportModule(key, module) {
		modules[key] = createModule(module);

		return modules[key];
	};

	/* Pages */
	var createPage = function createPage(page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};

	var exportPage = function exportPage(key, page) {
		pages[key] = createPage(page);

		return pages[key];
	};

	var checkForPage = function checkForPage(pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num=' + pageIdNum + ']').attr('data-page-id');

		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-' + currPage);
			pages[pageIdNum].pageLoad('#page-' + currPage);
		}
	};

	/* Components */
	var createComponent = function createComponent(component) {
		return $.extend({ init: $.noop }, component);
	};

	var exportComponent = function exportComponent(key, component) {
		components[key] = createPage(component);

		return pages[key];
	};

	var start = function start() {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');

		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');

		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}

		currPathname = currPathname !== '/' ? currPathname : 'home';

		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}

		if (lang !== defaultLang) {
			if (currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('/')[0];

		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});

		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);

		return Fw;
	};

	global.Fw = $.extend(global.Fw, {
		data: '',

		modules: {
			models: function models() {
				return modules;
			},

			export: exportModule
		},

		component: {
			models: function models() {
				return components;
			},

			export: exportComponent
		},

		page: {
			models: function models() {
				return pages;
			},

			export: exportPage,

			checkForPage: checkForPage
		},

		start: start
	});
})(jQuery, window);
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});
(function ($, undefined) {

	'use strict';

	var win;
	var winWidth;
	var winHeight;
	var items;

	var autoScreenHeight = function autoScreenHeight() {
		items.each(function () {
			var t = $(this);
			var attr = t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
			var offset = t.data('autoScreenOffset') !== undefined ? t.data('autoScreenOffset').replace(/\s+/g, '').split(',') : 0;
			var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
			var offsetHeight = 0;

			$.each(offset, function (i) {
				var t = $(offset[i]);
				offsetHeight += t.outerHeight();
			});

			var newHeight = winHeight * factor - offsetHeight;

			t.css(attr, newHeight);
		});
	};

	var init = function init() {
		win = $(window);
		winWidth = win.width();
		winHeight = win.height();
		items = $('.js-auto-screen-height');

		autoScreenHeight();

		win.resize(function () {
			winWidth = win.width();
			winHeight = win.height();

			autoScreenHeight();
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {
	'use strict';

	var headerCom;
	var checkout;
	var utils;

	function toggleCart() {
		if ($('body').hasClass('cart-open')) {
			closeCart();
		} else {
			openCart();
		}
	}

	function openCart(callback) {
		var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';

		$('.cart').on(transitionEnd, function (e) {
			$(document).on('click', outsideClickCart);
			$('.cart').off(transitionEnd);

			if (typeof callback === 'function') {
				callback();
			}
		});

		$('.cart').addClass('open');
		$('body').addClass('cart-open');
		headerCom.removeScroll();
	}

	function closeCart() {
		$('.cart').removeClass('open');
		$('body').removeClass('cart-open');
		$(document).off('click', outsideClickCart);
		headerCom.applyScroll();
	}

	function outsideClickCart(event) {
		if (!$(event.target).closest('.cart').length) {
			closeCart();
		}
	}

	function cardAddCart() {
		var t = $(this);
		var item = t.closest('.shop-product');
		var qty = 1;

		processAddCart({
			id: item.attr('data-id'),
			isbn: item.attr('data-isbn'),
			authors: item.attr('data-authors'),
			qty: qty
		});
	}

	function detailAddCart() {
		var t = $(this);
		var item = t.closest('.product-detail');
		var chosenOption = t.closest('.options-table-ctn').find('.product-detail-item-choice:checked');
		var data = {
			id: item.attr('data-id'),
			isbn: item.attr('data-isbn'),
			authors: item.attr('data-authors'),
			qty: 1
		};

		if (chosenOption.hasClass('product-set')) {
			data.setIds = chosenOption.val();
		}

		processAddCart(data);
	}

	function processAddCart(params) {
		var qty = parseInt(params.qty);
		var cartData = {
			ids: params.id,
			quantities: qty,
			getCart: true
		};
		var setId = '[data-set-id=""]';

		if (params.setIds) {
			cartData.setIds = params.setIds;
			setId = '[data-set-id="' + params.setIds + '"]';
		}

		footerProcessing();

		$.ajax({
			url: '/action/ajaxAddCart',
			cache: false,
			data: cartData,
			success: function success(response) {
				updatePrice(response);
				updateBtns(params.id);
				handleCartItems(response, params.authors, params.isbn);
				updateCount();

				openCart(function () {
					var currentCartItem = $('.cart-item[data-product-id="' + params.id + '"]' + setId);
					var target = currentCartItem.position().top;

					$('.cart__content').animate({ scrollTop: target }, 500, function () {
						currentCartItem.addClass('standing');

						setTimeout(function () {
							currentCartItem.removeClass('standing');
						}, 500);
					});
				});
			}
		});
	}

	function handleCartItems(cartData, authors, isbn) {
		if (cartData) {
			cartData = typeof cartData == "string" ? JSON.parse(cartData) : cartData;
			var products = cartData[0];
			var cartPopup = $('.cart__content');
			var cartItems = $('.cart-item:not(.clone)', cartPopup);

			for (var k in products) {
				var cartItemData = products[k];
				var currentCartItem = cartItems.filter("[data-id=" + cartItemData.id + "]");
				if (currentCartItem.length === 0) {
					var clone = createCartPopupItem(cartItemData, '.cart-item.clone', authors, isbn);
					clone.hide();
					cartPopup.append(clone);
					clone.slideDown();
				} else {
					updateCartItemUi(cartItemData, currentCartItem, authors, isbn);
				}
			}
		}
	}

	function createCartPopupItem(cartItemData, templateItem) {
		var authors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
		var isbn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

		var cartItemTemplate = $(templateItem).clone(true);
		cartItemTemplate.removeClass('clone');

		updateCartItemUi(cartItemData, cartItemTemplate, authors, isbn);

		return cartItemTemplate;
	}

	function updateCartItemUi(cartItemData, cartItem) {
		var authors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
		var isbn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

		var currItemId = cartItem.attr('data-id');
		var name = utils.decodeText(cartItemData.name);
		var description = utils.decodeText(cartItemData.shortDescription);
		var authorsEl = $('.cart-item__info[data-info="author"] .cart-item__info_val', cartItem);
		var isbnEl = $('.cart-item__info[data-info="isbn"] .cart-item__info_val', cartItem);

		$('.cart-item__price-unit', cartItem).attr('data-price', cartItemData.price);
		$('.cart-item__price-total', cartItem).html(utils.formatNumberToMoney(cartItemData.price));
		$('.cart-qty-input', cartItem).val(cartItemData.quantity);
		$('.cart-qty-input', cartItem).attr('data-default', cartItemData.quantity);

		// update following info if new item only 
		if (currItemId === '') {
			cartItem.attr('data-id', cartItemData.id);
			cartItem.attr('data-product-id', cartItemData.productId);
			if (cartItemData.productSetInfos) {
				if (cartItemData.productSetInfos.id) {
					cartItem.attr('data-set-id', cartItemData.productSetInfos.id);
				}
				if (cartItemData.productSetInfos.name) {
					name += ' - ' + utils.decodeText(cartItemData.productSetInfos.name);
				}
			}
			$('.cart-item__title', cartItem).html(name);
			$('.cart-item__desc', cartItem).html(description);
			$('.cart-item__image img', cartItem).attr('src', '/static/uploaded/Catalog/' + cartItemData.mediaId + '-preview.jpg');
			$('.cart-item__image img', cartItem).attr('alt', name);
			$('.cart-item__price-unit_val', cartItem).html(utils.formatNumberToMoney(cartItemData.unitPrice));
			if (authors.length !== 0 || isbn.length !== 0) {
				authors.length !== 0 ? authorsEl.html(authors) : authorsEl.hide();
				isbn.length !== 0 ? isbnEl.html(isbn) : isbnEl.hide();
			} else {
				$('.cart-item__toggle-detail', cartItem).addClass('cart-item__toggle-detail_invisible');
			}
		}
	}

	function updateBtns(id) {
		$('.product-detail[data-id=' + id + ']').find('.qty-input').val(1).trigger('keyup');
	}

	function changeQty() {
		var t = $(this);

		setTimeout(function () {
			checkDiffQty.apply(t);
		}, 100);
	}

	function checkDiffQty() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var input = $('.cart-qty-input', item);
		var defaultVal = parseInt(input.attr('data-default'));
		var currCount = parseInt(input.val());

		updateBtns(item.attr('data-id'));

		if (currCount !== defaultVal) {
			$('.cart-item__price-update', item).addClass('show');
		} else {
			$('.cart-item__price-update', item).removeClass('show');
		}
	}

	function submitQtyChange() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var id = item.attr('data-id');
		var input = $('.cart-qty-input', item);
		var currCount = parseInt(input.val());
		input.attr('data-default', currCount);
		$('.cart-item__price-update', item).removeClass('show');
		updateItemPrice(item, currCount);
		updateCount();
		footerProcessing();

		$.ajax({
			url: '/action/ajaxAddCart',
			cache: false,
			data: {
				ids: item.attr('data-id'),
				quantities: currCount,
				getCart: true,
				override: true
			},
			success: function success(response) {
				if (currCount === 0) {
					$('.cart-item[data-id=' + id + ']').slideUp(function () {
						$(this).remove();
					});
				}
				updatePrice(response);
				updateBtns(item.attr('data-id'));
				if ($('.checkout__recap').length > 0) {
					checkout.updateRecap();
				}
			}
		});
	}

	var updateItemPrice = function updateItemPrice(item, qty) {
		var unitPrice = parseFloat($('.cart-item__price-unit', item).attr('data-price'));
		$('.cart-item__price-total', item).text(formatMoney(unitPrice * qty));
	};

	function cancelQtyChange() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var input = $('.cart-qty-input', item);
		var defaultVal = parseInt(input.attr('data-default'));

		input.val(defaultVal);
		checkDiffQty.apply(input);
	}

	function deleteItem() {
		var t = $(this);
		var item = t.closest('.cart-item');
		var data = {
			ids: item.attr('data-id'),
			quantities: 0,
			getCart: true,
			override: true
		};

		if (item.attr('data-set-id') && item.attr('data-set-id').length > 0) {
			data.setIds = item.attr('data-set-id');
		}

		footerProcessing();
		$.ajax({
			url: '/action/ajaxAddCart',
			cache: false,
			data: data,
			success: function success(response) {
				updateBtns(item.attr('data-id'));
				item.slideUp(300, function () {
					item.remove();
					updateCount();
				});
				updatePrice(response);
			}
		});
	}

	function updateCount() {
		var count = 0;
		$('.cart-item:not(.clone) .cart-qty-input').each(function () {
			count += parseInt(this.value);
		});

		$('.cart__header_title-count, .header__cart span').text(count);
	}

	function updatePrice(response) {
		var cartJson = (typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' ? response : JSON.parse(response);
		var cartInfo = cartJson[cartJson.length - 1];
		var promoAmt = cartInfo.promoAmount;

		$('.cart__footer-review').removeClass('is-processing');
		$('.cart__subtotal').text(formatMoney(cartInfo.subtotal));
		$('.cart__total').text(formatMoney(cartInfo.subtotalWithPromo));
		if (promoAmt !== '0.00' && promoAmt !== '0,00') {
			$('.cart__promo').html('-' + formatMoney(promoAmt));
		} else {
			$('.cart__promo').html(formatMoney(0));
		}
	}

	function footerProcessing() {
		$('.cart__footer-review').addClass('is-processing');
	}

	var init = function init() {
		headerCom = Fw.modules.models().header;
		checkout = Fw.component.models().checkout;
		utils = Fw.component.models().utils;

		$('body').on('click', '.cart-item__toggle-detail', function () {
			var item = $(this).closest('.cart-item');
			$('.cart-item__info-ctn', item).slideToggle(200);
			item.toggleClass('open-info');
		});

		$('body').on('click', '.cart-change-qty-btn.minus, .cart-change-qty-btn.plus', changeQty);
		$('body').on('input', '.cart-qty-input', checkDiffQty);
		$('body').on('click', '.cart-item__price-update_btn', submitQtyChange);
		$('body').on('click', '.cart-item__price-update_cancel-btn', cancelQtyChange);
		$('body').on('click', '.cart-item__delete-btn', deleteItem);

		$('.btn-add-cart').click(cardAddCart);
		$('.product-detail__add-to-cart-btn').click(detailAddCart);
	};

	$(init);

	Fw.modules.export('cart', {
		toggleCart: toggleCart,
		openCart: openCart,
		closeCart: closeCart,
		cardAddCart: cardAddCart
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var utils;

	var displayAuthor = function displayAuthor() {
		var btn = $(this);
		var id = btn.attr('data-id');
		var ctn = btn.closest('.com-authors__tab-content');
		var currAuthor = ctn.find('.author.active');

		if (id !== currAuthor.attr('data-id')) {
			ctn.find('.com-authors__tab-content-author-btn').removeClass('active');
			currAuthor.fadeOut(function () {
				$(this).removeClass('active');

				btn.addClass('active');
				ctn.find('.author[data-id=' + id + ']').fadeIn(function () {
					$(this).addClass('active');
				});
			});
		}
	};

	var fetchBooks = function fetchBooks() {
		var showMax = 3;

		$('.author.js-fetch-books').each(function () {
			var t = $(this);

			$.ajax({
				url: '/action/ajaxGetProduct',
				cache: false,
				data: {
					genDataId: t.attr('data-id'),
					columnName: 'add_text_field1'
				},
				success: function success(response) {
					if (response.length > 0) {
						for (var book in response) {
							var clone = t.find('.author__book.clone').clone().removeClass('clone');
							var img = clone.find('.author__book-img');

							clone.attr('href', clone.attr('href') + '/' + response[book].friendlyUrl);
							img.attr('src', img.attr('data-prefix') + response[book].mediaId + img.attr('data-suffix'));
							img.attr('alt', utils.decodeText(response[book].name));
							clone.find('.author__book-name').html(utils.decodeText(response[book].name));

							if (parseInt(book) + 1 > showMax) {
								clone.addClass('hide element-to-toggle');
							}

							t.find('.author__books-ctn').append(clone);
						}

						t.find('.author__books-outer-ctn').removeClass('processing');
						if (response.length > showMax) {
							t.find('.author__books-toggle-btn-ctn').fadeIn();
						}

						var authorCopy = $('.author.copy-fetch[data-id="' + t.attr('data-id') + '"]');

						if (authorCopy.length > 0) {
							var childrenCtnClone = t.find('.author__books-ctn').clone();
							authorCopy.find('.author__books-ctn').append(childrenCtnClone.children());
							authorCopy.find('.author__books-outer-ctn').removeClass('processing');

							if (response.length > showMax) {
								authorCopy.find('.author__books-toggle-btn-ctn').fadeIn();
							}
						}
					} else {
						t.find('.author__books-outer-ctn').slideUp();
					}
				}
			});
		});
	};

	var init = function init() {
		utils = Fw.component.models().utils;
		$('.com-authors__tab-content-author-btn').click(displayAuthor);

		if ($('.author.js-fetch-books').length > 0) {
			fetchBooks();
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($) {
	'use strict';

	$(window).ready(function () {
		var $slider = $(".com-product-slider");

		if ($slider.length > 0) {
			$slider.on("init", function (event, slick) {
				$(slick.$slider).parent().removeClass("hidden");
			});

			$slider.slick({
				slidesToShow: 5,
				slidesToScroll: 5,
				prevArrow: $(".com-product-slider-arrow-nav.prev"),
				nextArrow: $(".com-product-slider-arrow-nav.next"),
				responsive: [{
					breakpoint: 1440,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4
					}
				}, {
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});
		}
	});
})(jQuery);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

	'use strict';

	var createSelects = function createSelects() {
		var selects = document.querySelectorAll('select.change-select-js');

		for (var i = 0; i < selects.length; i++) {
			var select = selects[i];
			var options = select.querySelectorAll('option');
			var parent = select.parentNode;
			var newSelect = document.createElement('div');
			var optionsContainer = document.createElement('div');
			var selectedValue = document.createElement('div');
			var optionsValues = '';

			for (var k = 0; k < select.attributes.length; k++) {
				var selectAttr = select.attributes[k];
				selectedValue.setAttribute(selectAttr.name, selectAttr.nodeValue || selectAttr.value);
			}

			newSelect.className = 'select-changed-js';

			optionsContainer.className = 'select-options-container';

			selectedValue.classList.remove('change-select-js');
			selectedValue.classList.add('select-value');
			selectedValue.setAttribute('tabindex', '0');

			for (var j = 0; j < options.length; j++) {
				var option = options[j];
				var newOption = document.createElement('div');
				var value = getValue(option);
				newOption.setAttribute('data-value', value);
				newOption.innerText = option.innerText;

				for (var l = 0; l < option.attributes.length; l++) {
					var optionAttr = option.attributes[l];
					newOption.setAttribute(optionAttr.name, optionAttr.nodeValue || optionAttr.value);
				}

				if (option.selected) {
					selectedValue.innerText = newOption.innerText;
					selectedValue.setAttribute('data-value', value);
					newOption.className = 'select-option selected hover';
				} else {
					newOption.className = 'select-option';
				}

				if (optionsValues.length) {
					optionsValues += '\n';
				}
				optionsValues += option.innerText;

				optionsContainer.appendChild(newOption);
			}

			newSelect.setAttribute('data-items', optionsValues);

			newSelect.appendChild(selectedValue);
			newSelect.appendChild(optionsContainer);
			parent.insertBefore(newSelect, select);
			parent.removeChild(select);

			setupListeners(newSelect, selectedValue, optionsContainer);
		}
	};

	var setupListeners = function setupListeners(newSelect, selectValue, optionsContainer) {
		var options = optionsContainer.querySelectorAll('.select-option');

		selectValue.addEventListener('mousedown', toggleOptionsContainer);
		newSelect.addEventListener('focusin', startListeningForKeys);
		newSelect.addEventListener('focusout', stopListeningForKeys);

		for (var i = 0; i < options.length; i++) {
			var option = options[i];
			option.addEventListener('mouseup', updateSelectedValue);
			option.addEventListener('mouseover', optionOver);
			option.addEventListener('mouseout', optionOver);
		}
	};

	var optionOver = function optionOver(e) {
		if (e.type === 'mouseout') {
			var target = document.elementFromPoint(e.clientX, e.clientY);
			if (target) {
				if (target.classList.contains('select-option')) {
					this.classList.remove('hover');
				}
			}
			this.removeEventListener('mousemove', optionOver);
		} else if (e.type === 'mouseover' || e.type === 'mousemove') {
			var hovered = getHovered(this.parentNode);

			if (e.type === 'mouseover' || hovered !== this) {
				hovered.classList.remove('hover');
				this.classList.add('hover');
			}

			if (e.type === 'mouseover') {
				this.addEventListener('mousemove', optionOver);
			}
		}
	};

	var startListeningForKeys = function startListeningForKeys() {
		window.addEventListener('keydown', selectKeydown);
		this.classList.add('select-focused');
	};

	var stopListeningForKeys = function stopListeningForKeys() {
		window.removeEventListener('keydown', selectKeydown);
		this.classList.remove('select-focused');
	};

	var selectKeydown = function selectKeydown(e) {
		var container = document.querySelector('.select-focused .select-options-container');
		var isOpened = container.classList.contains('show-options');
		var key = getKey(e.code || e.which);

		// Allows for other keys to work as they should
		if (key.isOneOfKeys || isOpened && !key.isOneOfKeys) {
			e.preventDefault();
			e.stopPropagation();

			if (key.code === 'Tab' || key.code === 9) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (isOpened) {
			if (key.isEnter || key.isEscape) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		} else {
			if (key.isSpace) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (key.isUp) {
			goToPrevValue(container, e);
		} else if (key.isDown) {
			goToNextValue(container, e);
		} else if (key.isKey) {
			goToNextKeyValue(container, e, key.code);
		}
	};

	var toggleOptionsContainer = function toggleOptionsContainer() {
		var options = this.nextElementSibling;
		var currentHover = getHovered(options);
		var currentSelected = getSelected(options);

		options.classList.toggle('show-options');

		currentHover.classList.remove('hover');
		currentSelected.classList.add('hover');

		if (options.classList.contains('show-options')) {
			setTimeout(function () {
				window.addEventListener('mousedown', closeToggled);
			}, 1);
		} else {
			window.removeEventListener('mousedown', closeToggled);
		}
	};

	var closeToggled = function closeToggled(e) {
		var classesRegex = /select-option|select-changed-js|select-value|select-options-container/;
		var target = e.target;
		var isSelect = false;
		if (e.target.className.match(classesRegex)) {
			if (target.classList.contains('select-focused')) {
				isSelect = true;
			} else {
				while (target) {
					if (target.classList.contains('select-focused')) {
						isSelect = true;
						break;
					} else if (!target.className.match(classesRegex)) {
						break;
					}
					target = target.parentNode;
				}
			}
		}

		if (!isSelect) {
			var containers = document.querySelectorAll('.show-options');
			for (var i = 0; i < containers.length; i++) {
				var option = containers[i];
				toggleOptionsContainer.apply(option.previousElementSibling);
			}
		}
	};

	var updateSelectedValue = function updateSelectedValue(e, fromKey) {
		var parent = this.parentNode;
		var select = parent.parentNode;
		var selectedValue = parent.previousElementSibling;
		var previousOption = getSelected(parent);
		var previousOver = getHovered(parent);
		var changeEvent;

		if (typeof window.CustomEvent === 'function') {
			changeEvent = new CustomEvent('change', {
				originalEvent: e,
				type: 'change'
			});
		} else {
			changeEvent = document.createEvent('CustomEvent');
			changeEvent.initCustomEvent('change', true, true, {
				originalEvent: e,
				type: 'change'
			});
		}

		e.preventDefault();

		previousOption.classList.remove('selected');
		this.classList.add('selected');

		selectedValue.setAttribute('data-value', this.getAttribute('data-value'));
		selectedValue.innerHTML = this.innerHTML;

		if (!fromKey) {
			toggleOptionsContainer.apply(selectedValue);
		} else {
			parent.scrollTop = this.offsetTop;
			previousOver.classList.remove('hover');
			this.classList.add('hover');
		}

		if (selectedValue.dispatchEvent) {
			selectedValue.dispatchEvent(changeEvent);
		} else {
			selectedValue.fireEvent(changeEvent);
		}
	};

	var goToPrevValue = function goToPrevValue(container, e) {
		var hover = getHovered(container);
		var prev = hover.previousElementSibling;

		if (prev) {
			updateSelectedValue.apply(prev, [e, true]);
		}
	};

	var goToNextValue = function goToNextValue(container, e) {
		var hover = getHovered(container);
		var next = hover.nextElementSibling;

		if (next) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var goToNextKeyValue = function goToNextKeyValue(container, e, key) {
		var hover = getHovered(container);
		var options = container.querySelectorAll('.select-option');
		var found = false;
		var isNumber = !isNaN(key);
		var keyReplaced = isNumber ? 'asdsadas' : key.replace(/Key|Digit/, '');
		var next = hover;

		for (var i = 0; i < options.length; i++) {
			next = next.nextElementSibling;

			if (!next) {
				next = container.children[0];
			}

			if (isNumber) {
				if (next.innerHTML.charCodeAt(0) === key) {
					found = true;
					break;
				}
			} else {
				if (next.innerHTML.charAt(0).toUpperCase() === keyReplaced) {
					found = true;
					break;
				}
			}
		}

		if (found) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var getValue = function getValue(option) {
		if (!option.hasAttribute('value')) {
			return option.innerText;
		} else {
			return option.getAttribute('value');
		}
	};

	var getKey = function getKey(key) {
		var data = {
			code: key,
			isEnter: false,
			isKey: false,
			isEscape: false,
			isSpace: false,
			isUp: false,
			isDown: false,
			isOneOfKeys: false,
			keyValue: undefined
		};
		var isNumber = key >= 48 && key <= 57;
		var isLetter = key >= 65 && key <= 90;

		if (key === 13 || key === 'Enter') {
			data.isEnter = true;
		} else if (key === 27 || key === 'Escape') {
			data.isEscape = true;
		} else if (key === 32 || key === ' ' || key === 'Space') {
			data.isSpace = true;
		} else if (key === 38 || key === 37 || key === 'ArrowLeft' || key === 'ArrowUp') {
			data.isUp = true;
		} else if (key === 40 || key === 39 || key === 'ArrowRight' || key === 'ArrowDown') {
			data.isDown = true;
		} else if (isNumber || isLetter || /[a-z0-9]{1}/i.test(key) && key.length === 1 || /(Key[A-Z])|(Digit[0-9])/.test(key)) {
			data.isKey = true;

			if (isNumber || isLetter) {
				keyValue = String.fromCharCode(key);
			} else {
				keyValue = key;
			}
		}

		if (data.isEnter || data.isEscape || data.isSpace || data.isUp || data.isDown || data.isKey) {
			data.isOneOfKeys = true;
		}

		return data;
	};

	var getHovered = function getHovered(container) {
		var hover = container.querySelector('.hover');

		if (!hover) {
			hover = container.querySelector('.select-option');
		}

		return hover;
	};

	var getSelected = function getSelected(container) {
		var selected = container.querySelector('.selected');

		if (!selected) {
			selected = container.querySelector('.select-option');
		}

		return selected;
	};

	var getSelectValue = function getSelectValue(selectCtn) {
		var selectItem;
		if (typeof selectCtn === 'string') {
			selectItem = document.querySelector(selectCtn);
			if (!selectItem) {
				return null;
			}
		} else if ((typeof selectCtn === 'undefined' ? 'undefined' : _typeof(selectCtn)) === 'object') {
			if (selectCtn[0]) {
				selectItem = selectCtn[0];
			} else {
				return null;
			}
		} else if (selectCtn && selectCtn.nodeType) {
			selectItem = selectCtn;
		} else {
			return null;
		}

		try {
			return selectItem.querySelector('.select-value').getAttribute('data-value');
		} catch (ex) {
			console.error(ex);
			return null;
		}
	};

	$(document).ready(function () {
		createSelects();
	});

	var customSelect = Fw.component.export('customSelect', {
		val: getSelectValue
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var init = function init() {
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
			$('html').addClass('mobile');
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var initSlider = function initSlider() {
		$('.com-events').each(function () {
			var component = $(this);
			var slider = component.find('.all-events');

			slider.on('init', function (event, slick) {
				component.find('.events-genlist-item').removeClass('hidden');
			});

			slider.slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				prevArrow: component.find('.arrow-btn.prev'),
				nextArrow: component.find('.arrow-btn.next'),
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1
					}
				}]
			});
		});
	};

	var init = function init() {
		if ($('.events-genlist-item').length > 0) {
			initSlider();
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var addExternalLinkTarget = function addExternalLinkTarget() {
		$.expr[':'].external = function (obj) {
			var hostname = obj.hostname === '' ? location.hostname : obj.hostname;

			return !obj.href.match(/^mailto\:/) && hostname != location.hostname && !obj.href.match(/^javascript\:/) && !obj.href.match(/^tel\:/) && !obj.href.match(/^$/) || obj.href.match(/\.pdf$/);
		};

		$('a:external').attr('target', '_blank');
	};

	var init = function init() {
		addExternalLinkTarget();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var doc = $(document);
	var currPage;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
	var selectCountry;

	var validateForm = function validateForm(ctn) {
		ctn.each(function () {
			var t = $(this);
			var toValidateItems = $('.form-input.required:not(.select-state-input:not(.selected))', t);
			var toValidateUpload = $('.form-input-upload.required', t);
			var toValidateCheck = $('.form-check-input.required', t);
			var password = $('.js-password', t);
			var passwordConfirm = $('.js-password-confirm', t);
			var email = $('.js-email', t);
			var emailConfirm = $('.js-email-confirm', t);
			var btn = $('.js-form-btn', t);
			var isOk = true;
			var passwordOk = true;
			var termsOk = true;
			var checkOk = true;
			var emailOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', t);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
			var fieldsErrorTerms = $('.js-form-error-message.terms', t);
			var fieldsErrorPassword = $('.js-form-error-message.password', t);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', t);

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild);
				if (tChild.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateUpload.each(function () {
				var tUpload = $(this);
				var input = $('.form-input-upload-input', tUpload);

				if (input.val() === '') {
					tUpload.addClass('error');
				}

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (!tCheck.is(':checked')) {
					tCtn.addClass('error');

					if (tCtn.attr('name') !== 'terms') {
						checkOk = false;
					}
				} else {
					tCtn.removeClass('error');
				}

				if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
					termsOk = false;
				}

				if (tCtn.hasClass('error')) {
					termsOk = false;
				}
			});

			if (password.length !== 0 && passwordConfirm.length !== 0 && (password.val() !== passwordConfirm.val() || password.val().length === 0)) {
				if (password.val().length === 0) {
					password.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					password.addClass('success').removeClass('error');
					passwordOk = true;
				}

				if (password.val() !== passwordConfirm.val() || passwordConfirm.val().length === 0) {
					passwordConfirm.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					passwordConfirm.removeClass('error');
					passwordOk = true;

					if (password.val().length !== 0) {
						passwordConfirm.addClass('success');
					}
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}

				if (email.val() !== emailConfirm.val() || email.val().length === 0) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}

			t.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}

			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}

			if (password.length !== 0 && passwordConfirm.length !== 0) {
				if (password.length !== 0 && passwordOk) {
					ctn.addClass('has-password');
					password.add(passwordConfirm).removeClass('error');
					fieldsErrorPassword.slideUp(300);
				} else {
					ctn.removeClass('has-password');
					password.add(passwordConfirm).addClass('error');
					fieldsErrorPassword.slideDown(300);
				}
			}

			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}

			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !passwordOk || !termsOk || !checkOk || !emailOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};

	var validateField = function validateField(elt) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.val();
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var emailValid = true;
		var whiteSpaceValid = true;
		var urlValid = true;
		var telValid = true;
		var inputValid = true;
		var errorMessage = classTarget.next('.tmpl-form-error-message');

		if (!val.replace(/\s/g, '').length) {
			whiteSpaceValid = false;
		}

		if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.add(elt).hasClass('required') && elt.val() !== '') {
				classTarget.add(elt).removeClass('error').addClass('success');
				errorMessage.slideUp(200);
			} else {
				classTarget.add(elt).addClass('error').removeClass('success');
				errorMessage.slideDown(200);
			}
		} else {
			classTarget.add(elt).addClass('success').removeClass('error');
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.add(elt).removeClass('success').addClass('error');
				errorMessage.slideDown(200);
				inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.add(elt).removeClass('success').removeClass('error');
				errorMessage.slideUp(200);
			}
		}

		if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
			classTarget.add(elt).removeClass('error').addClass('success');
			errorMessage.slideUp(200);
		} else if (val.length === 0 && !classTarget.hasClass('required')) {
			classTarget.add(elt).removeClass('error').removeClass('success');
			errorMessage.slideUp(200);
		} else {
			classTarget.add(elt).addClass('error').removeClass('success');
			errorMessage.slideDown(200);
		}
	};

	var formItemsBlur = function formItemsBlur(t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('.js-form');

		validateField(elt);

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function formCheckChange() {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');

		if (form.hasClass('is-checked')) {
			validateForm(form);

			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function checkLabelClick() {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');

		if (input.hasClass('is-checked')) {
			input.removeClass('is-checked');
		} else {
			input.addClass('is-checked');
		}
	};

	var toggleCheckbox = function toggleCheckbox() {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};

	var fileInputChange = function fileInputChange() {
		var t = $(this);
		var label = t.closest('.form-input-upload-input-label');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.form-input-upload-input-label-value', label);
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		var form = ctn.closest('.js-form');

		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
			labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);
		} else {
			ctn.addClass('error').removeClass('success');
			labelValue.html(labelDefault);
		}

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formSwitchClick = function formSwitchClick() {
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop("checked")) {
			elem.removeAttr("checked");
		} else {
			elem.attr("checked", "checked");
		}
	};

	var updateStateSelect = function updateStateSelect() {
		var t = $(this);
		var val = t.val();
		var id = t.attr('data-id');
		var curCls = 'other';
		var statesCtn = $('.select-state-ctn[data-id="' + id + '"]');
		var inputCtn = $('.select-state-input-ctn', statesCtn);

		inputCtn.removeClass('selected');
		inputCtn.find('.required').addClass('derequired').removeClass('required');

		if (val === 'CA' || val === 'CAN' || val === 'canada' || val === 'Canada') {
			curCls = 'canada';
		} else if (val === 'US' || val === 'USA' || val === 'United-States' || val === 'united-states') {
			curCls = 'us';
		}
		inputCtn.filter('.' + curCls).addClass('selected').find('.form-select').addClass('selected');
		inputCtn.filter('.' + curCls).find('.derequired').addClass('required').removeClass('derequired');
	};

	var itemFocusIn = function itemFocusIn() {
		var elt = $(this);
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;

		classTarget.addClass('focus');
	};

	var itemFocusOut = function itemFocusOut() {
		var elt = $(this);
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;

		classTarget.removeClass('focus');
	};

	var validateAndSubmit = function validateAndSubmit(event) {
		if (event) event.preventDefault();
		var form = $(this);

		validateForm(form);

		if (form.hasClass('has-error')) {
			$('button[type="submit"]', form).removeAttr('disabled');
			return false;
		}

		form.find('button').addClass('disabled');

		if (form.hasClass('checkout__form') && form.find('.use-shipping-check').prop('checked')) {
			form.find('input[name=billFirstName]').val(form.find('input[name=firstName]').val());
			form.find('input[name=billLastName]').val(form.find('input[name=lastName]').val());
			form.find('input[name=billStreet]').val(form.find('input[name=street]').val());
			form.find('input[name=billStreet2]').val(form.find('input[name=street2]').val());
			form.find('input[name=billCity]').val(form.find('input[name=city]').val());
			form.find('input[name=billZip]').val(form.find('input[name=zip]').val());
			form.find('select[name=billCountry]').val(form.find('select[name=country]').val());
			form.find('select[name=billCountry]').trigger('change');
			form.find('select[name=billState]').val(form.find('.select-state-input-ctn.selected select[name=state]').val());
		}

		if (form.find('.select-state-input-ctn').length > 0) {
			form.find('.select-state-input-ctn:not(.selected)').remove();
		}
		this.submit();
	};

	var init = function init() {
		body = $('body');
		items = $('.form-input:not([type=file])');

		checkLabel = $('.register-checkbox-label');
		checkboxItems = $('.form-input-checkbox');
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
		file = $('.form-input-upload');
		fileInput = $('.form-input-upload-input', file);
		formSwitch = $('.form-switch');
		formCheck = $('.form-check-input');
		selectCountry = $('.select-country-input');

		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
		selectCountry.change(updateStateSelect);
		items.focusin(itemFocusIn);
		items.focusout(itemFocusOut);

		items.each(function () {
			if (!$(this).hasClass('no-blur')) {
				$(this).blur(formItemsBlur);
			}
		});

		$('form.validate-and-submit').on('submit', validateAndSubmit);
	};

	$(init);

	var form = Fw.component.export('form', {
		init: init,
		validateForm: validateForm
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var cartCom;
	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;

	var header;
	var navItems;

	var toggleMenuBtn;
	var toggleSearchBtn;

	var toggleScroll = function toggleScroll() {
		if ($('html').hasClass('no-scroll')) {
			applyScroll();
		} else {
			removeScroll();
		}
	};

	var applyScroll = function applyScroll() {
		$('html').removeClass('no-scroll');
		changeScrollDiff(0);
	};

	var removeScroll = function removeScroll() {
		var w1 = win.width();
		$('html').addClass('no-scroll');
		var w2 = win.width();
		changeScrollDiff(w2 - w1);
	};

	var changeScrollDiff = function changeScrollDiff(diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};

	var onClickMenuToggle = function onClickMenuToggle() {
		if (!!$('body').hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			$('body').removeClass('menu-open');
			$(document).off('click', outsideClickMenu);

			header.one(transitionEnd, function (e) {
				applyScroll();
				$('.header__shop-window__cats, .header__shop-window').removeClass('open');
			});
		} else {
			openMenu();
			$(document).on('click', outsideClickMenu);
		}
	};

	var openMenu = function openMenu() {
		$('body').addClass('menu-open');
		removeScroll();
	};

	var outsideClickMenu = function outsideClickMenu(event) {
		if (!$(event.target).closest('.site-header').length) {
			closeMenu();
		}
	};

	var closeMenu = function closeMenu() {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			applyScroll();
			$(document).off('click', outsideClickMenu);
		}
	};

	var toggleSearch = function toggleSearch() {
		$('.site-header').toggleClass('search-open');
		$('.header__search-bar [name=q]').focus();
	};

	var changeCats = function changeCats(e) {
		var t = $(this);
		var currId = t.attr('data-id');
		var currHref = t.attr('href');

		$('.header__shop-window__parent-cats_link').removeClass('selected');
		t.addClass('selected');
		$('.header__shop-window__cats_item').removeClass('show');
		$('.header__shop-window__cats_item[data-parent-id="' + currId + '"]').addClass('show');

		$('.header__shop-window__cats_item.all a').attr('href', currHref);

		if ($('.header__nav').css('position') === 'fixed' && e.type === 'click' && t.attr('data-id') !== undefined) {
			$('.header__shop-window__cats').addClass('open');

			return false;
		}
	};

	var mobileOpenMenu = function mobileOpenMenu() {
		var t = $(this).closest('.header__shop-btn');
		if ($('.header__nav').css('position') === 'fixed') {
			$('.header__shop-window', t).addClass('open');

			return false;
		}
	};

	var mobileCloseMenu = function mobileCloseMenu() {
		$('.header__shop-window').removeClass('open');
		return false;
	};

	var closeCats = function closeCats() {
		$('.header__shop-window__cats').removeClass('open');
		return false;
	};

	var toggleLang = function toggleLang() {
		$(this).closest('.site-header-lang').toggleClass('open');
	};

	var init = function init() {
		cartCom = Fw.modules.models().cart;
		winWidth = win.width();
		winHeight = win.height();
		$('body').removeClass('no-scroll');

		header = $('.site-header');
		navItems = $('.nav-item-link', header);

		toggleMenuBtn = $('.header__mobile-menu-toggle-btn', header);
		toggleSearchBtn = $('.header__search-btn, .header__search-bar__close-btn', header);

		if ($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}

		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);
		toggleSearchBtn.on('click', toggleSearch);
		$('.header__shop-window__parent-cats_link:not(.all)').hover(changeCats);
		$('.header__shop-window__parent-cats_link:not(.all)').click(changeCats);
		$('.header__shop-btn > a').click(mobileOpenMenu);
		$('.header__shop-window_back-to-cats').click(closeCats);
		$('.header__shop-window_back-to-menu').click(mobileCloseMenu);
		$('.header__bg').click(closeMenu);
		$('.header__cart').click(cartCom.toggleCart);
		$('.cart__header_close-btn').click(cartCom.closeCart);
		$('.site-header-lang-curr').click(toggleLang);
	};

	$(init);

	Fw.modules.export('header', {
		toggleScroll: toggleScroll,
		applyScroll: applyScroll,
		removeScroll: removeScroll
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var initSlider = function initSlider() {
		var slider = $('.product-detail__img-slider');

		slider.on('init', function (event, slick) {
			slider.find('.product-detail__img').removeClass('hidden');
		});

		slider.each(function () {
			if ($(this).hasClass('popup')) {
				$(this).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					fade: true,
					prevArrow: $('.product-detail__img-popup-slider-arrow.prev'),
					nextArrow: $('.product-detail__img-popup-slider-arrow.next'),
					asNavFor: $('.product-detail__img-slider:not(.popup)')
				});
			} else {
				$(this).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					fade: true,
					asNavFor: $('.product-detail__img-slider.popup'),
					appendDots: $('.product-detail__img-dots')
				});
			}
		});
	};

	var initAuthorsSlider = function initAuthorsSlider() {
		var slider = $('.product-detail__authors-slider');
		var ctn = $('.product-detail__authors-ctn');

		slider.on('init', function (event, slick) {
			slider.find('.author').removeClass('hide');
		});

		slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			fade: true,
			draggable: false,
			prevArrow: ctn.find('.arrow-btn.prev'),
			nextArrow: ctn.find('.arrow-btn.next')
		});
	};

	var init = function init() {
		if ($('.product-detail__img-slider').find('.product-detail__img').length > 1) {
			initSlider();
		}
		if ($('.product-detail__authors-slider').find('.author').length > 0) {
			if ($('.product-detail__tab.authors.selected').length > 0) {
				initAuthorsSlider();
			} else {
				$('.product-detail__tab.authors').click(function () {
					if ($('.product-detail__authors-slider:not(.slick-slider)')) {
						initAuthorsSlider();
					}
				});
			}
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var contactFormBtn;
	var formCom;
	var recaptcha;

	var sendContactFormEmailClass = function sendContactFormEmailClass() {
		var t = $(this);
		var count = t.data('count');
		var form = t.closest($('.contactForm-Container'));
		var subject = $('.contactForm-subject', form).val();
		var email = $('.contactForm-email', form).val();
		var targetEmail = $('.targetEmail', form) ? $('.targetEmail', form).val() : "";
		var content = null;
		var captchaIsOk = true;
		var appendField = "";

		formCom.validateForm(form);

		if (form.hasClass('has-error')) {
			$('.js-form-error-message.fields', form).slideDown(200);
			grecaptcha.reset();
		} else {
			$('.js-form-error-message.fields', form).slideUp(200);
		}

		try {
			content = tinyMCE.get('contactForm-content', form).getContent();
		} catch (exception) {
			content = $('.contactForm-content', form).val();
		}

		if ($('.fieldName1') !== null) {
			var total = 9;
			if (count) {
				total = count;
			}
			for (var i = 1; i < total; i++) {
				appendField += "&fieldName" + i + "=" + encodeURIComponent($('.fieldName' + i, form).val());
				if ($('.field' + i, form).attr('type') == "checkbox") {
					if ($('.field' + i, form).checked) {
						appendField += "&field" + i + "=checked.";
					} else {
						appendField += "&field" + i + "=not checked.";
					}
				} else {
					appendField += "&field" + i + "=" + encodeURIComponent($('.field' + i, form).val());
				}
			}
			appendField += "&count=" + total + "&targetEmail=" + targetEmail;
		}

		if (t.hasClass('render-g-recaptcha')) {
			var captchaResp = grecaptcha.getResponse();

			if (captchaResp.length === 0) {
				captchaIsOk = false;
			} else {
				appendField += '&captcha=' + grecaptcha.getResponse();
			}
		} else if (recaptchaResponse && typeof recaptchaResponse === 'string') {
			appendField += '&captcha=' + recaptchaResponse;
		}

		if (!captchaIsOk) {
			$('.contact-form-captcha-error', form).slideDown(200);
			grecaptcha.reset();
		} else {
			$('.contact-form-captcha-error', form).slideUp(200);
		}

		if (!form.hasClass('has-error') && captchaIsOk) {
			ajax(actionPath + "contactUs?subject=" + encodeURIComponent(subject) + "&email=" + encodeURIComponent(email) + "&content=" + encodeURIComponent(content) + appendField, sendContactFormEmailConfirmClass(form));
		}
	};

	var sendContactFormEmailConfirmClass = function sendContactFormEmailConfirmClass(form) {
		var bigCtn = form.closest('.contactForm-Container-big');

		$('.contactForm-Container', bigCtn).slideUp(1000, function () {
			$('.contactForm-sent', bigCtn).slideDown(300);
		});
	};

	var popErrorCompleteDisplayOnSite = function popErrorCompleteDisplayOnSite(response) {
		footerErrorMessage.slideDown(200);
	};

	var init = function init(page) {
		contactFormBtn = $('.js-contact-form-send');
		formCom = Fw.component.models().form;
		recaptcha = Fw.component.models().utils.recaptcha;

		if (contactFormBtn.hasClass('render-g-recaptcha')) {
			contactFormBtn.each(function () {
				var btn = this;
				if (btn.classList.contains('render-g-recaptcha')) {
					recaptcha(btn, function (response) {
						sendContactFormEmailClass.call(btn, response);
					});
				}
			});
		} else {
			contactFormBtn.click(sendContactFormEmailClass);
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($) {
    'use strict';

    var utils;
    var $t11Inputs;
    var $d1Inputs;

    function filter(e) {
        var arr = [];
        var t11q = "";
        var searchOn = false;

        $t11Inputs.each(function () {
            if (this.checked) {
                if (t11q !== "") t11q += ",";
                t11q += this.value;
            }
        });
        if (t11q !== "") {
            arr.push("t11=" + t11q);
            searchOn = true;
        }
        if ($d1Inputs[0].checked) {
            arr.push("range2=" + $d1Inputs.val());
            searchOn = true;
        }
        if (utils.getUrlParameter('q') && utils.getUrlParameter('q').length > 0) {
            arr.push("q=" + utils.getUrlParameter('q'));
            searchOn = true;
        }
        if (searchOn) {
            arr.push("search=true");
        }

        if (utils.getUrlParameter('categoryId') != undefined) {
            arr.push('categoryId=' + utils.getUrlParameter('categoryId'));
        }

        window.location.href = $('.shop-filters').attr('data-url') + '?' + arr.join("&");
    }

    function openSidebar(e) {
        var id = this.getAttribute("data-id");
        $("#" + id).addClass("open");
    }
    function closeSidebar(e) {
        var id = this.getAttribute("data-id");
        $("#" + id).removeClass("open");
    }

    var init = function init() {
        utils = Fw.component.models().utils;
        $t11Inputs = $(".sidebar__filter-t11 input");
        $d1Inputs = $(".sidebar__filter-d1 input");

        $t11Inputs.on("change", filter);
        $d1Inputs.on("change", filter);

        $('.sidebar__trigger').click(function () {
            $(this).parent().toggleClass('sidebar__item_active');
        });

        $(".mobile-sidebar-open-btn").click(openSidebar);
        $(".mobile-sidebar-close-btn").click(closeSidebar);
    };

    $(window).ready(function () {
        init();
    });
})(jQuery);
(function ($, undefined) {

	'use strict';
	// Create a Stripe client.

	var validateForm = function validateForm() {
		var stripeKey = $("html").attr("data-is-dev") === 'true' ? 'pk_test_HhX3YNMlO2VMhFdx6AFnBe3q' : $('#stripe-cc-form').attr('data-key');
		var button = $('.get-stripe-token');
		var cardErrorsId = "card-errors";
		var ccFieldsId = "#stripe-cc-form";
		var ccFields = $(ccFieldsId);
		var form = button.closest('form');
		var style = JSON.parse($(ccFieldsId).data('style'));

		var stripe = Stripe(stripeKey, { locale: $('html').attr('lang') });

		if (ccFields.length !== 0) {
			// Create an instance of Elements.
			var elements = stripe.elements();

			//// Create an instance of the card Element. Remove hidePostalCode if PC validation required
			var card = elements.create('card', {
				hidePostalCode: true, style: style });

			card.mount(ccFieldsId);

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function (event) {
				var displayError = document.getElementById(cardErrorsId);
				if (event.error) {
					displayError.textContent = event.error.message;
				} else {
					displayError.textContent = '';
				}
			});

			// Handle form submission.
			button.on('click', function (event) {
				event.preventDefault();
				button.prop('disabled', true);

				stripe.createToken(card).then(function (result) {
					if (result.error) {
						// Inform the user if there was an error.
						button.removeAttr('disabled');
						var errorElement = document.getElementById(cardErrorsId);
						errorElement.textContent = result.error.message;
					} else {
						// Send the token in a stripeToken param in the payment
						var m;
						if (result.token.card.exp_month < 10) {
							m = '0' + result.token.card.exp_month;
						} else {
							m = result.token.card.exp_month;
						}

						$('input[name=CCType].cc-type').val(result.token.card.brand);
						$('input[name=cardToken]').val(result.token.id);
						$('input[type=hidden].cc').val(result.token.card.last4);
						$('input[type=hidden].mm').val(m);
						$('input[type=hidden].yy').val(result.token.card.exp_year.toString().substring(2));

						form.submit();
					}
				});
			});
		}
	};

	var stripeToken = Fw.component.export('stripeToken', {
		init: validateForm
	});
})(jQuery);
(function ($) {
	// $('.table-of-contents-action.action-contents').click(e => {
	// 	e.preventDefault();
	// 	$('body, html').addClass('no-scroll');
	// 	$('#table-of-contents').fadeIn();
	// });
	// $('.table-of-contents__background, .table-of-contents__close').click(e => {
	// 	e.preventDefault();
	// 	$('body, html').removeClass('no-scroll');
	// 	$('#table-of-contents').fadeOut();
	// 	$('#excerpt').fadeOut();
	// });

	// $('.table-of-contents-action.action-excerpt').click(e => {
	// 	e.preventDefault();
	// 	$('body, html').addClass('no-scroll');
	// 	$('#excerpt').fadeIn();
	// });
})(jQuery);
(function ($, undefined) {
	'use strict';

	var initSlider = function initSlider() {
		$('.com-text-images').each(function () {
			var component = $(this);
			var slider = component.find('.text-images-pics-ctn');

			if (slider.find('.text-images-pic').length > 1) {
				slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true
				});
			}
		});
	};

	var init = function init() {
		if ($('.text-images-pics-ctn').length > 0) {
			initSlider();
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var toggleElement = function toggleElement() {
		var t = $(this);
		var ctn = t.closest('.toggle-outer-ctn');
		var el = ctn.find('.element-to-toggle');

		if (!el.length) {
			el = $('.element-to-toggle[data-id=' + t.attr('data-id') + ']');
		}

		if (t.hasClass('close-all')) {
			$('.element-to-toggle').each(function () {
				if ($(this).attr('data-id') !== t.attr('data-id')) {
					$(this).slideUp();
				}
			});
		}

		el.each(function () {
			if ($(this).css('display') !== 'none' && $(this).find('input, select').hasClass('required')) {
				$(this).find('input.required, select.required').removeClass('required').addClass('derequired').closest('.tmpl-form-input-big').removeClass('required').addClass('derequired');
			} else if ($(this).css('display') === 'none' && $(this).find('input, select').hasClass('derequired')) {
				$(this).find('input.derequired, select.derequired').removeClass('derequired').addClass('required').closest('.tmpl-form-input-big').removeClass('derequired').addClass('required');
			}

			if ($(this).css('display') !== 'none' && $(this).find('input, select').hasClass('form-submit-input')) {
				$(this).find('input.form-submit-input, select.form-submit-input').removeClass('form-submit-input').addClass('no-submit-input');
			} else if ($(this).css('display') === 'none' && $(this).find('input, select').hasClass('no-submit-input')) {
				$(this).find('input.no-submit-input, select.no-submit-input').removeClass('no-submit-input').addClass('form-submit-input');
			}
		});

		if (ctn.length > 0) {
			ctn.toggleClass('open');
		} else {
			t.toggleClass('open');
		}
		el.slideToggle(function () {
			if ($(this).css('display') === 'none' && $(this).hasClass('empty-inputs-on-close')) {
				$(this).find('input, select').val('').removeClass('success error').closest('.tmpl-form-input-big').removeClass('success error');
			}
		});
	};

	var typeNumbersOnly = function typeNumbersOnly(e) {
		var allowed = [0, 8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

		if ($(this).hasClass('phone')) {
			allowed.push(45);
		}

		if (!e.shiftKey && allowed.indexOf(e.which) !== -1) {
			return true;
		} else {
			e.preventDefault();
			return false;
		}
	};

	var qtyInputChange = function qtyInputChange() {
		var t = $(this);
		var number = parseInt(t.val());
		var min = parseInt(t.attr('min') || Number.MIN_SAFE_INTEGER);
		var max = parseInt(t.attr('max') || Number.MAX_SAFE_INTEGER);
		var minusBtn = t.closest('.qty-input-ctn').find('.qty-input-btn.minus');
		var plusBtn = t.closest('.qty-input-ctn').find('.qty-input-btn.plus');

		if (number <= min) {
			t.val(min);
			minusBtn.addClass('disabled').attr('disabled', true);
		} else {
			minusBtn.removeClass('disabled').removeAttr('disabled');
		}
		if (number >= max) {
			t.val(max);
			plusBtn.addClass('disabled').attr('disabled', true);
		} else {
			plusBtn.removeClass('disabled').removeAttr('disabled');
		}
	};

	var changeQty = function changeQty() {
		var t = $(this);
		var input = t.closest('.qty-input-ctn').find('.qty-input');
		var number = parseInt(input.val());

		if (t.hasClass('minus')) {
			input.val(number - 1);
		} else if (t.hasClass('plus')) {
			input.val(number + 1);
		}

		input.trigger('keyup');
	};

	var initQtyInputs = function initQtyInputs(ctn) {
		ctn.on('keypress', 'input.numbers-only', typeNumbersOnly);
		ctn.on('keyup', 'input.qty-input', qtyInputChange);
		ctn.on('click', '.qty-input-btn', changeQty);
	};

	var init = function init() {
		initQtyInputs($('body'));
		$('body').on('click', '.toggle-trigger-element:not(input[type=radio])', toggleElement);
		$('body').on('change', 'input[type=radio].toggle-trigger-element', toggleElement);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var sitekey = '6LeEFbIUAAAAAAhlXZ0teARuHaeTX037HcGWI3y9';

	/* RECAPTCHA UTIL FUNCTION */
	/**
  * Render recaptchas dynamically.
  * @param   btn         An element referencing the button or a string 
  *                      referencing the Id of the element.
  * @param   callback    A function to be called after recaptcha has 
  *                      completed its check. The function is passed back
  *                      the recaptcha response and the form element.
  * @param   validate    (optional) A boolean to know if a form needs to be 
  *                      validated using the formValidator in com/form.js.
  * @param   form        (optional) A jQuery object reference the form to be
  *                      validated using formValidator in com/form.js.
  */

	var recaptcha = function recaptcha(btn, _callback, validate, form) {
		if (btn && window.grecaptcha) {
			if (window.grecaptcha.render) {
				grecaptcha.render(btn, {
					'sitekey': sitekey,
					'callback': function callback(response) {
						var formValidator = Fw.component.models().form.validateForm;
						var validated = true;
						if (validate) {
							validated = false;
							formValidator(form);
							if (!form.hasClass('has-error')) {
								validated = true;
							}
						}

						if (validated) {
							_callback(response, form);
						} else {
							grecaptcha.reset();
						}
					},
					'badge': 'inline'
				});
			} else {
				setTimeout(function () {
					recaptcha(btn, _callback, validate, form);
				}, 250);
			}
		} else if (btn && !window.grecaptcha) {
			setTimeout(function () {
				recaptcha(btn, _callback, validate, form);
			}, 250);
		}
	};

	var updateItemTop = function updateItemTop(extraOffset, item, ctn, outerCtn) {
		ctn.each(function () {
			var t = $(this);
			var outerCtnHeight = t.closest(outerCtn).outerHeight();

			if (t.closest(outerCtn) !== null && outerCtnHeight > $(window).height()) {
				var ctnHeight = t.outerHeight();
				var itemOffset = t.offset().top;
				var imgHeight = t.find(item).outerHeight();
				var windowTop = $(window).scrollTop();

				var addedOffset = windowTop - itemOffset + $('.site-header').outerHeight() + extraOffset;

				if (windowTop >= itemOffset - $('.site-header').outerHeight()) {
					if (addedOffset + imgHeight <= ctnHeight) {
						t.find(item).css('top', addedOffset + 'px');
					} else {
						t.find(item).css('top', ctnHeight - imgHeight + 'px');
					}
				} else {
					t.find(item).css('top', '0px');
				}
			} else {
				t.find(item).css('top', '0px');
			}
		});
	};

	var decodeText = function decodeText(text) {
		if (text !== undefined) {
			return text.replace(/\\xE0/g, '\xE0').replace(/\\xE2/g, '\xE2').replace(/\\xE3/g, '\xE3').replace(/\\xE4/g, '\xE4').replace(/\\xE5/g, '\xE5').replace(/\\xE7/g, '\xE7').replace(/\\xE9/g, '\xE9').replace(/\\xE8/g, '\xE8').replace(/\\xEA/g, '\xEA').replace(/\\xEB/g, '\xEB').replace(/\\xED/g, '\xED').replace(/\\xEE/g, '\xEE').replace(/\\xEF/g, '\xEF').replace(/\\xF1/g, '\xF1').replace(/\\xF2/g, '\xF2').replace(/\\xF3/g, '\xF3').replace(/\\xF4/g, '\xF4').replace(/\\xF6/g, '\xF6').replace(/\\xF9/g, '\xF9').replace(/\\xFB/g, '\xFB').replace(/\\xFC/g, '\xFC').replace(/\\xC0/g, '\xC0').replace(/\\xC2/g, '\xC2').replace(/\\xC7/g, '\xC7').replace(/\\xC8/g, '\xC8').replace(/\\xC9/g, '\xC9').replace(/\\xCA/g, '\xCA').replace(/\\xCB/g, '\xCB').replace(/\\xCE/g, '\xCE').replace(/\\xCF/g, '\xCF').replace(/\\xD1/g, '\xD1').replace(/\\xD4/g, '\xD4').replace(/\\xD9/g, '\xD9').replace(/\\xDB/g, '\xDB').replace(/\\xDC/g, '\xDC');
		}
		return text;
	};

	var decryptISO = function decryptISO(text) {
		return eval('"' + text + '"');
	};

	/* http://www.jquerybyexample.net/2012/06/get-url-parameters-using-jquery.html */
	var getUrlParameter = function getUrlParameter(sParam) {
		var sPageURL = window.location.search.substring(1);
		var sURLVariables = sPageURL.split('&');
		for (var i = 0; i < sURLVariables.length; i++) {
			var sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] == sParam) {
				return sParameterName[1];
			}
		}
	};

	// from Tokan
	var formatNumberToMoney = function formatNumberToMoney(number) {
		if (typeof number == "string") {
			number = parseFloat(number.replace(',', '.'));
		}
		if (isNaN(number)) {
			return null;
		}
		var lang = $("html").attr('lang');
		var moneyString = "";
		if (lang !== 'fr') {
			moneyString += '$';
		}
		moneyString += number.toFixed(2);
		if (lang == 'fr') {
			moneyString = moneyString.replace(".", ",");
			moneyString += '$';
		}
		return moneyString;
	};

	Fw.component.export('utils', {
		recaptcha: recaptcha,
		updateItemTop: updateItemTop,
		decodeText: decodeText,
		decryptISO: decryptISO,
		getUrlParameter: getUrlParameter,
		formatNumberToMoney: formatNumberToMoney
	});
})(jQuery);
(function ($) {
    'use strict';

    /* INIT ON DOM INTERACT */

    // Admin authors

    $(".admin-author-popup-books-btn").on("click", openBookPopup);
    $(".admin-book-list-popup").on("click", closeBookPopup);
    $(".admin-book-list-popup .admin-book-item").on("click", selectBook);
    $(".admin-book-list-popup .admin-book-list-save-btn").on("click", saveAuthorBooks);

    function reloadPage() {
        window.location.reload();
    }

    function openBookPopup(e) {
        var $item = $(this).closest(".admin-author-row");
        var bookIds = $item.attr("data-book-ids").split(",");
        var $popup = $(".admin-book-list-popup");
        var $bookList = $popup.find(".admin-book-item");

        // Pre-select all of the saved items
        $bookList.removeClass("selected");
        for (var i = 0; i < bookIds.length; i++) {
            $bookList.filter(".product" + bookIds[i]).addClass("selected");
        }
        $popup.attr("data-author-id", $item.attr("data-id")).show();
    }

    function closeBookPopup(e) {
        var ctn = e.currentTarget || this;
        var targ = e.target;

        if ($(targ).closest(".close-popup-btn")[0] || targ.compareDocumentPosition(ctn) === 0) {
            ctn.style.display = "none";
        }
    }

    function selectBook(e) {
        $(this).toggleClass("selected");
    }

    function saveAuthorBooks(e) {
        var $it = $(this);
        var $popup = $it.closest(".admin-book-list-popup");
        var authorId = $popup.attr("data-author-id");
        var $selectedBooks = $popup.find(".admin-book-item.selected");
        var arr = [];

        if (isNaN(authorId) || $it.hasClass("disabled")) {
            return; // Not a valid id, abort
        }

        $it.addClass("disabled");
        // Gather the ids of the selected items
        $selectedBooks.each(function () {
            arr.push(this.getAttribute("data-id"));
        });
        // Submit the data in field7
        $.ajax({
            type: "post",
            method: "post",
            url: "/action/manageGenData",
            data: "ajax=true&id=" + authorId + "&field7=" + arr.join(","),
            complete: function complete() {
                reloadPage();
            }
        });
    }
})(jQuery);
(function ($, undefined) {
	'use strict';

	var stripe;
	var utils;

	var lang = lang || document.documentElement.lang;
	var tax1Label = lang === "fr" ? "TPS" : "GST";
	var tax2Label = lang === "fr" ? "TVQ" : "QST";

	var updateCartTop = function updateCartTop() {
		if ($('.responsive-detector-sm').css('visibility') === 'hidden') {
			utils.updateItemTop(20, $('.checkout__recap'), $('.checkout__right'), $('.checkout__inner'));
		}
	};

	var updateRecap = function updateRecap() {
		var data = {
			ajax: true
		};

		if ($('.shipping-fee-country').length > 0 && $('.shipping-fee-country').val().length > 0) {
			data.country = $('.shipping-fee-country').val();
		}
		if ($('.select-state-input.required').length > 0 && $('.select-state-input.required').val().length > 0) {
			data.state = $('.select-state-input.required').val();
		}
		data.shippingMethod = $('.shipping-method-select').val();

		$.ajax({
			url: '/action/shopJsonCart',
			cache: false,
			data: data,
			success: function success(response) {
				var ctn = $('.checkout__recap');
				var cartInfo = response[response.length - 1];

				$('.promo-name', ctn).html(cartInfo.promoCode);
				var promoAmt = cartInfo.promoAmount;

				if (promoAmt !== '0.00' && promoAmt !== '0,00') {
					$('.promo-val', ctn).html('-' + formatMoney(promoAmt));
					$('.cart__promo').html('-' + formatMoney(promoAmt));
				} else {
					$('.promo-val', ctn).html('');
					$('.cart__promo').html(formatMoney(0));
				}

				var items = response[0];
				for (var item in Object.keys(items)) {
					var qty = items[item].quantity;
					var price = items[item].price;
					var el = $('.cart-item[data-id=' + items[item].id + ']', ctn);

					el.find('.checkout__recap-qty').html('x' + qty);
					el.find('.cart-item__price-total').html(price.indexOf(',') !== -1 ? price + '$' : '$' + price);
				}

				$('.shipping', ctn).html(formatMoney(cartInfo.shipping));
				$('.tax1-name', ctn).html(cartInfo.tax1Name || tax1Label);
				$('.tax1', ctn).html(formatMoney(cartInfo.TPS));
				if (cartInfo.TVQ) {
					$('.tax2-name', ctn).html(cartInfo.tax2Name || tax2Label);
					$('.tax2', ctn).html(formatMoney(cartInfo.TVQ)).closest('.checkout__recap-amount').removeClass('hide');
				} else {
					$('.tax2-name', ctn).html('');
					$('.tax2', ctn).html('').closest('.checkout__recap-amount').addClass('hide');
				}
				$('.total', ctn).html(formatMoney(cartInfo.total));
				$('.cart__total').html(formatMoney(cartInfo.subtotalWithPromo));
				$('.subtotal', ctn).html(formatMoney(cartInfo.subtotal));
			}
		});
	};

	var updatePostalCode = function updatePostalCode() {
		$('.shipping-postalcode-text').html(this.value);
	};

	var applyPromoCode = function applyPromoCode() {
		var btn = $(this);
		var codeInput = btn.closest('.checkout__promo-ctn').find('.promo-code-input');
		var err = $('.promo-code-invalid');
		var errExpired = $('.promo-code-expired');
		var suc = $('.promo-code-valid');

		suc.slideUp();
		err.slideUp();
		errExpired.slideUp();

		if (codeInput.val().length === 0) {
			codeInput.closest('.tmpl-form-input-big').addClass('error');
		} else {
			codeInput.closest('.tmpl-form-input-big').removeClass('error');

			var data = {
				"code": codeInput.val(),
				"ajax": true
			};

			$.ajax({
				url: '/action/shopApplyPromo',
				cache: false,
				data: data,
				success: function success(response) {
					if (response.indexOf('invalid') !== -1) {
						err.slideDown();
					} else if (response.indexOf('expired') !== -1) {
						errExpired.slideDown();
					} else {
						suc.slideDown();
						updateRecap();
						btn.addClass('hide');
						$('.checkout__promo-cancel-ctn').removeClass('hide');
						$('.checkout__recap-amount.promo').slideDown();
					}
				}
			});
		}
	};

	var removePromoCode = function removePromoCode() {
		var btn = $(this);
		var codeInput = btn.closest('.checkout__promo-ctn').find('.promo-code-input');
		var data = {
			"remove": true,
			"ajax": true
		};

		$.ajax({
			url: '/action/shopApplyPromo',
			cache: false,
			data: data,
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					$('.promo-code-valid').slideUp();
					updateRecap();
					$('.checkout__promo-submit-btn').removeClass('hide');
					$('.checkout__promo-cancel-ctn').addClass('hide');
					$('.checkout__recap-amount.promo').slideUp();
					codeInput.val('').closest('.tmpl-form-input-big').removeClass('success error has-value');
				}
			}
		});
	};

	var init = function init() {
		utils = Fw.component.models().utils;
		stripe = Fw.component.models().stripeToken;

		if ($('#stripe-cc-form').length > 0) {
			stripe.init();
		}

		if ($('.checkout__recap').length > 0) {
			updateCartTop();
			$(window).scroll(function () {
				updateCartTop();
			});
			$(window).resize(function () {
				updateCartTop();
			});
		}

		$('.shipping-fee-country, .shipping-method-select, .select-state-input').change(updateRecap);
		$('.shipping-postalcode-input').change(updatePostalCode);

		$('.checkout__promo-submit-btn').click(applyPromoCode);
		$('.checkout__promo-cancel-btn').click(removePromoCode);
	};

	$(window).ready(init);

	var checkout = Fw.component.export('checkout', {
		updateRecap: updateRecap
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var s = $(window).scrollTop();
	var utils;

	function checkSelectedSection() {
		var checkFold = s + $(window).height() / 3; /*(($(window).height() / 3) * 2)*/
		var firstVisibleElement = getFirstCompletelyVisibleElement($('.directory__cat_title'));
		var parent = firstVisibleElement.closest('.directory__cat');

		if (parent.length == 0) {
			parent = getFirstPartiallyVisibleElement($('.directory__cat'));
		}

		$('.directory__cat').not(parent).removeClass('selected');
		parent.addClass('selected');
		$('.sidebar__trigger').removeClass('selected');
		$('.sidebar__trigger[data-directory-id=' + parent.attr('data-id') + ']').addClass('selected');
	}

	var getFirstCompletelyVisibleElement = function getFirstCompletelyVisibleElement(elements) {
		return elements.filter(function (i, el) {
			var elTop = $(el).offset().top;
			var scrollTop = $(window).scrollTop();
			return elTop >= scrollTop && elTop + $(el).outerHeight() <= scrollTop + $(window).height();
		}).first();
	};
	var getFirstPartiallyVisibleElement = function getFirstPartiallyVisibleElement(elements) {
		return elements.filter(function (i, el) {
			var elTop = $(el).offset().top;
			var scrollTop = $(window).scrollTop();
			return elTop <= scrollTop + $(window).height() && elTop + $(el).outerHeight() >= scrollTop;
		}).first();
	};

	var updateSidebarTop = function updateSidebarTop() {
		if ($('.responsive-detector-xs').css('visibility') === 'hidden') {
			utils.updateItemTop(20, $('.sidebar__inner'), $('.sidebar'), $('.directory__inner'));
		}
	};

	var init = function init() {
		utils = Fw.component.models().utils;

		if ($('.directory').length > 0) {
			updateSidebarTop();
			$(window).scroll(function () {
				updateSidebarTop();
			});
			$(window).resize(function () {
				updateSidebarTop();
			});
		}

		$('[data-directory-id]').click(function () {
			var t = $(this);
			var id = t.attr('data-directory-id');
			var section = $('.directory__cat[data-id="' + id + '"]');
			var headerH = $('.site-header').outerHeight();
			var target = section.offset().top - headerH;

			$('html').scrollTop(target);
		});

		if ($('.sidebar').length !== 0 && $('.directory__content').length !== 0) {
			// checkCatDocked();
			checkSelectedSection();

			$(window).scroll(function () {
				s = $(window).scrollTop();
				// checkCatDocked();
				checkSelectedSection();
			});
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var init = function init() {};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var exportJson = function exportJson() {
		var selected = $('.mg2_manageGenList_item').filter(function () {
			return $('input[name="mg2_manageGenList_item_checkbox"]', $(this)).is(':checked');
		});

		var json = {};

		selected.each(function () {
			var info = $('.mg2_manageGenList_item_info', $(this));
			var id = info.attr('data-id');
			var total = parseInt(info.attr('data-attr-total'));
			var extraData = info.attr('data-extradata');

			json[id] = {
				id: id,
				extraData: extraData
			};

			for (var i = 0; i <= total; i++) {
				if (info.attr('field' + i) !== undefined) {
					json[id]['field' + i] = info.attr('field' + i);
				}
			}
		});

		$('.mg2_manageGenList_result').html(JSON.stringify(json));
	};

	var importJson = function importJson() {
		var jsonString = $('.mg2_manageGenList_import').val();
		var json = JSON.parse(jsonString);
		var count = 0;
		var total = Object.keys(json).length;

		for (var key in json) {
			var data = {
				extraData: json[key].extraData,
				ajax: true
			};

			for (var k = 1; k <= 26; k++) {
				data['field' + k] = json[key]['field' + k];
			}

			//Fetch id for duplicates
			$('.mg2_manageGenList_adminid').each(function () {
				if ($(this).html() === json[key].field11) {
					data.id = $(this).closest('.mg2_manageGenList_item').find('.mg2_manageGenList_item_info').attr('data-id');
					console.log('Miller!');
				}
			});

			console.log(data);

			//ajax
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				success: function success(response) {
					count++;

					if (count === total) {
						alert('Done!');
					}
				}
			});
		}
	};

	var init = function init() {
		exportJson();

		$('input[name="mg2_manageGenList_item_checkbox"]').change(exportJson);
		$('.mg2_manageGenList_import_btn').click(importJson);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($) {
    'use strict';

    $(window).ready(function () {
        var $slider = $(".similar-products__slider");

        $slider.on("init", function (event, slick) {
            $(slick.$slider).parent().removeClass("hidden");
        });

        $slider.slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            prevArrow: $(".similar-product-slider-arrow-nav.prev"),
            nextArrow: $(".similar-product-slider-arrow-nav.next"),
            responsive: [{
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    });
})(jQuery);
(function ($, undefined) {

	'use strict';

	var formCom;

	var init = function init() {
		formCom = Fw.component.models().form;

		$('.toolkit-validate-form').click(function () {
			formCom.validateForm($('.toolkit-form'));
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);